<template>
	<div class="container_head ">
		<div class="detail">
			<!-- <img :src="img" alt="" class="poster"> -->
			<div class="pd15">
				<div class="title" v-show='columnId!=="bdyw"&&columnId!=="xxgg"'>{{title}}</div>
				<div class="desc" v-html="content"></div>
				<van-divider :style="{ margin: '10px 0' }" />
				<div class="ckxq">
					<div class="time">{{time}}</div>
					<!-- <div class="fbr">{{fbr}} </div> -->
				</div>
				<div class="lunbo" v-show="imglist.length>0">
					<van-swipe :autoplay="3000">
						<van-swipe-item v-for="(image, index) in imglist" :key="index">
							<a>
								<img :src="image" width="100%" height="100%" @click="getImg(index)"/>
							</a>
						</van-swipe-item>
					</van-swipe>
				</div>
				<div class="fujian" v-show="doclist.length>0">
					<div class="fjtitle">
						<span>附件列表</span>
					</div>
					<a class="xiazai" :href="item.src" v-for="(item,index) in doclist" :key="index">
						<div class="fj-icon">
							<van-icon name="description" size="24" color="#4892FB" />
						</div>
						<div class="fj-info">
							<div class="fj-name">{{item.name}}</div>
							<div class="fj-hint">点击下载查看</div>
						</div>
						<div class="fj-arrow">
							<van-icon name="arrow" size="16" color="#999" />
						</div>
					</a>
				</div>
				<div class="fujian" v-show="videolist.length>0">
					<div class="fjtitle">
						<span>视频</span>
					</div>
					<video :src="'https://zhwy.zjj.suqian.gov.cn/'+item.src" v-for="(item,index) in videolist" :key="index" controls></video>
				</div>
			</div>
			
		</div>
	</div>
</template>

<script>
	import Vue from 'vue';
	import {
		Divider,ImagePreview,Icon
	} from 'vant';
	Vue.use(Divider).use(Icon);
	export default {
		data() {
			return {
			    title:'',
				time:'',
				content:'',
				imglist:[],
				doclist:[],
				img:require('../../assets/grzx/test.png'),
				id:'',
				videolist:[],
				columnId:""
			};
		},
		mounted(e) {
			this.columnId = this.$route.params.columnId;
			if (this.columnId == "zbsh") {
				 this.$emit('fatherMethod',{
					 title:'支部生活详情'
				 })
				 this.requestdata2('/api/v1/wygl/partybranchlife/viewone')
			} else if (this.columnId == "xqgs") {
				this.$emit('fatherMethod',{
					title:'公示详情'
				})
				this.requestdata('/api/v1/wygl/publicity/view')
			} else if (this.columnId == "sqkb") {
				this.$emit('fatherMethod',{
					title:'快报详情'
				})
				this.requestdata('/api/v1/wygl/notice/view')
			} else if (this.columnId == "wdxx") {
				this.$emit('fatherMethod',{
					title:'消息详情'
				})
				this.requestdata3('/api/v1/wygl/mynews/viewone')
			} else if (this.columnId == "xxgg") {
				this.$emit('fatherMethod',{
					title:'政策法规'
				})
				this.requestdata6('/screen/v1/home/regulationsList/detail')
			}  else if (this.columnId == "bdyw") {
				this.$emit('fatherMethod',{
					title:'本地要闻'
				})
				this.requestdata4('/view/xxfb/viewLocalNews/viewDetail/')
			} else if (this.columnId == "hhb") {
				this.$emit('fatherMethod',{
					title:'业主首页'
				})
				this.requestdata5('/api/v1/wygl/ownersHomePage/viewone?webUrlId=')
			}
 
		},
		methods: {
			changeview(path) {
				this.$router.push(path);
			},
			requestdata(url){
				this.id=this.$route.query.id;
				this.$axios.get(url, {
					params: {
						commMessagesId:this.id,//公示详情和快报的
					}
				}).then(res => {
					console.log(res)
					this.title=res.title;
					this.content=res.content;
					this.time=res.publishDate;
					this.imglist = res.imgsurl.split(',') || []
					var doclist = res.docurl.split(',') || []
					var doclistname = res.docName.split(',') || []
					this.imglist.pop()
					doclist.pop()
					doclistname.pop()
					doclistname.forEach(element => {

						if(['m4v','mp4','mp3'].includes(element.substring(element.lastIndexOf("\.")+1,element.length))){
							this.videolist =  doclist.map((item,index)=>{
								return {
									name:doclistname[index],
									src:item
								}
							})
						}else{
							this.doclist = doclist.map((item,index)=>{
								return {
									name:doclistname[index],
									src:item
								}
							})
						}
					});
					
				});
			},
			//图片预览
			getImg(i){
				var that = this
				ImagePreview({
					
					images: that.imglist.map(item=>{
						return item
					}),
					showIndex: true,
					loop: true,
					startPosition: i
				});
			},
			requestdata2(url){
				this.id=this.$route.query.id;
				this.$axios.get(url, {
					params: {
						lifeId:this.id,//支部生活的
					}
				}).then(res => {
					this.title=res.partyLiftTitle;
					this.content=res.context;
					this.time=res.liftTime;
				});
			},
			requestdata3(url){
				this.id=this.$route.query.id;
				
				this.$axios.get(url, {
					params: {
						wechatTemplateMessageId:this.id,
						title:this.$route.query.type
					}
				}).then(res => {
					this.title=res.title;
					this.content=res.message;
					this.time=res.messageTime;
				});
			},

			requestdata4(url){
								this.id=this.$route.query.id;
				
				this.$axios.get(url+this.id, {
					params: {

					}
				}).then(res => {
					this.title=res.title;
					this.content=res.content;
					this.time=res.time;
				});
			},
			requestdata5(url){
								this.id=this.$route.query.id;

				this.$axios.get(url+this.id, {
					params: {

					}
				}).then(res => {
					this.title=res.title;
					this.content=res.content;
					this.time=res.time;
				});
			},
			requestdata6(url){//政策法规详情
				this.id=this.$route.query.id;
				this.$axios.get(url, {
					params: {
						id: this.id
					}
				}).then(res => {
					this.title = res.title;
					this.content = res.msgContent;
					this.time = res.publishDate;
					// 处理附件 - fj返回的是附件ID列表
					if(res.fj && Array.isArray(res.fj)) {
						this.doclist = res.fj.map(id => ({
							name: this.title,
							src: '/api/v1/common/download/' + id
						}));
					}
				});
			}
		}
	};
</script>

<style lang="less" scoped>

.flexcenter {
	display: flex;
	justify-content: center;
	align-items: center;
}

.lunbo {
	// margin-bottom: 5px;
	height: 28%;
	padding: 10px 10px 10px 10px;
	.van-swipe{
		height: 100%;
	}
}
.fujian{
	display: flex;
	flex-direction: column;
	margin-top: 10px;
	video{
		margin-top: 10px;
		height: 200px;
		width: 100%;
	}
	.fjtitle{
		height: 15px;
        width: 100%;
        font-size: 13px;
        border-left: 4px solid #28aff6;
        display: flex;
        align-items: center;
        position: relative;
        span {
          margin-left: 10px;
        }
	}
	.xiazai{
		display: flex;
		align-items: center;
		margin-top: 10px;
		padding: 12px;
		background-color: #f8f9fa;
		border-radius: 8px;
		text-decoration: none;
		transition: background-color 0.2s;
		&:active{
			background-color: #eef1f5;
		}
		.fj-icon{
			width: 40px;
			height: 40px;
			background-color: #e8f4fd;
			border-radius: 8px;
			display: flex;
			align-items: center;
			justify-content: center;
			flex-shrink: 0;
		}
		.fj-info{
			flex: 1;
			margin-left: 12px;
			overflow: hidden;
			.fj-name{
				font-size: 14px;
				color: #333;
				font-weight: 500;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
			}
			.fj-hint{
				font-size: 12px;
				color: #999;
				margin-top: 4px;
			}
		}
		.fj-arrow{
			flex-shrink: 0;
			margin-left: 8px;
		}
	}
}
.detail{
	
	background-color: #fff;
	overflow: hidden;
	border-radius: 10px;
	margin: 15px;
	.pd15{
		padding: 15px;
	}
	.poster{
		display: block;
		width: 100%;
		height: 150px;
		object-fit: cover;
	}
	.ckxq{
		overflow: hidden;
		font-size: 13px;
		.time{
			float: left;
		}
		.fbr{
			float: right;
		}
	}
	.title{
		font-size: 18px;
		font-weight: bold;
		margin-bottom: 5px;
		text-align: center;
	}
	/deep/.desc{
		color: #aaa;
		font-size: 14px;
		word-break: break-all;
		img{
			display: block;
			width: 100%!important;
		}
	}
}
</style>
